import { Box, Paper } from '@material-ui/core';
import { useCallback, useState } from 'react';
import ImageViewer from 'react-simple-image-viewer';
import CopyClipBoard from '../../common/CopyClipBoard';

function ImageViewList({ images, height, width, big, small }: any) {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };
  const refsize = height - 10;
  if (!images || images.length === 0) {
    return <Paper style={{ height, width, overflow: 'auto' }}></Paper>;
  }
  return (
    <div style={{ height, width, overflow: 'auto' }}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
        }}
      >
        {images.map((src: any, index: any) => (
          <Box style={{ position: 'relative' }}>
            <img
              src={src}
              onClick={() => openImageViewer(index)}
              width={refsize}
              height={refsize}
              key={index}
              style={{
                padding: big ? 10 : 5,
                overflow: 'hidden',
                objectFit: 'cover',
                cursor: 'pointer',
              }}
              alt=""
            />
            <Box
              style={{
                position: 'absolute',
                left: 8,
                bottom: 12,
                zIndex: 115,
              }}
            >
              <CopyClipBoard
                text={src}
                icon
                color="darkblue"
                size={18}
              ></CopyClipBoard>
            </Box>
          </Box>
        ))}

        {isViewerOpen && (
          <ImageViewer
            src={images}
            currentIndex={currentImage}
            onClose={closeImageViewer}
            disableScroll={false}
            backgroundStyle={{
              backgroundColor: 'rgba(0,0,0,0.7)',
              zIndex: 150,
            }}
            closeOnClickOutside={true}
          />
        )}
      </div>
    </div>
  );
}

export default ImageViewList;
